import React from 'react';

export const getIntegrationIcon = (type) => {
    if (type === 'slack') {
      return (
        <img
          src="https://customer-assets.emergentagent.com/job_test-automation-hub-5/artifacts/zq6va13s_image.png"
          alt="Slack"
          className="w-12 h-12 object-contain"
        />
      );
    } else if (type === 'discord') {
      return (
        <img
          src="https://customer-assets.emergentagent.com/job_test-automation-hub-5/artifacts/8eil66g1_image.png"
          alt="Discord"
          className="w-12 h-12 object-contain"
        />
      );
    } else if (type === 'jira') {
      return (
        <svg className="w-12 h-12" viewBox="0 0 256 256" fill="none">
          <defs>
            <linearGradient id="jira-gradient" x1="50%" y1="0%" x2="50%" y2="100%">
              <stop offset="0%" stopColor="#2684FF"/>
              <stop offset="100%" stopColor="#0052CC"/>
            </linearGradient>
          </defs>
          <rect width="256" height="256" rx="32" fill="url(#jira-gradient)"/>
          <path d="M128 28L52 104L80 132L128 84L176 132L204 104L128 28Z" fill="white"/>
          <path d="M128 84L52 160L80 188L128 140L176 188L204 160L128 84Z" fill="white" opacity="0.8"/>
        </svg>
      );
    }
  };

export const getIntegrationInfo = (type) => {
    if (type === 'slack') {
      return {
        title: 'Slack',
        description: 'Get real-time notifications in Slack when tests complete',
        setupUrl: 'https://api.slack.com/messaging/webhooks',
        webhookLabel: 'Slack Webhook URL',
        webhookPlaceholder: 'https://hooks.slack.com/services/...'
      };
    } else if (type === 'discord') {
      return {
        title: 'Discord',
        description: 'Receive test results and alerts in your Discord server',
        setupUrl: 'https://support.discord.com/hc/en-us/articles/228383668-Intro-to-Webhooks',
        webhookLabel: 'Discord Webhook URL',
        webhookPlaceholder: 'https://discord.com/api/webhooks/...'
      };
    } else if (type === 'jira') {
      return {
        title: 'Jira',
        description: 'One-click bug reports with screenshots, logs, and repro steps',
        setupUrl: 'https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/',
        tokenLabel: 'Jira API Token',
        tokenPlaceholder: 'Your Jira API token'
      };
    }
  };
